import { History } from "history";
import * as React from "react";
import {
  Router as ReactRouter,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";

import Home from "../../views/Home";
import Subscription from "../../views/Subscription";
import ConfirmByHash from "../../views/ConfirmByHash";
import Manage from "../../views/Manage";
import ManageConfirm from "../../views/ManageConfirm";
import ConfirmByMyzToken from "../../views/ConfirmByMyzToken";
import Feedback from "../../views/Feedback";
import Error from "../../views/Error";

import { BASE_PATH } from "../../../constants/endpoint";

type Props = {
  history: History;
};
type State = {};

class Router extends React.Component<Props, State> {
  public readonly state: State = {};

  render() {
    const { history } = this.props;

    return (
      <ReactRouter history={history}>
        <Switch>
          {/* schermata grigia */}
          <Route
            path={BASE_PATH}
            exact={true}
            render={({ location }) => {
              /* hash router backward compatibility */
              if (location.hash.startsWith("#/")) {
                return (
                  <Redirect
                    to={`${BASE_PATH}/${location.hash.replace("#/", "")}`}
                  />
                );
              }
              return <Home />;
            }}
          ></Route>

          {/* schermata arancione */}
          <Route path={`${BASE_PATH}/iscrizione`} exact={true}>
            <Subscription history={history} />
          </Route>

          {/* schermata azzurrina - pesce palla */}
          <Route path={`${BASE_PATH}/iscrizione/attesa`} exact={true}>
            <Feedback history={history} />
          </Route>

          {/* schermata gialla - squalo */}
          <Route path={`${BASE_PATH}/iscrizione/conferma`} exact={true}>
            <ConfirmByMyzToken history={history} />
          </Route>
          {/* schermata gialla - pesce palla */}
          <Route
            path={`${BASE_PATH}/iscrizione/conferma/:hash/:confirmCode`}
            exact={true}
            render={(props) => <ConfirmByHash {...props} />}
          />

          {/* schermata azzurra - pesce palla */}
          <Route path={`${BASE_PATH}/gestione/identificazione`} exact={true}>
            <Feedback history={history} />
          </Route>

          {/* schermata verde */}
          <Route path={`${BASE_PATH}/gestione/conferma`} exact={true}>
            <ManageConfirm history={history} />
          </Route>

          {/* schermata rosa - pesce palla */}
          <Route
            path={`${BASE_PATH}/gestione/:hash`}
            exact={true}
            render={(props) => <Manage {...props} history={history} />}
          />
          {/* schermata rosa - squalo */}
          <Route
            path={`${BASE_PATH}/gestione`}
            exact={true}
            render={(props) => <Manage {...props} history={history} />}
          />

          <Route path={`${BASE_PATH}/errore`} exact={true}>
            <Error />
          </Route>

          <Redirect to={BASE_PATH} />
        </Switch>
      </ReactRouter>
    );
  }
}

export default Router;
